
// @mui
import { styled } from '@mui/material/styles';
import { Link, Container, Typography, Divider, Stack, Box, Grid } from '@mui/material';
// hooks
import useResponsive from '../hooks/useResponsive';
// components
import Logo from '../components/logo';
import Iconify from '../components/iconify';
// sections
import { LoginForm } from '../sections/auth/login';

// ----------------------------------------------------------------------

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
  },
}));

const StyledSection = styled('div')(({ theme }) => ({
  width: '100%',
  maxWidth: 480,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  boxShadow: theme.customShadows.card,
  backgroundColor: theme.palette.background.default,
}));

const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 480,
  margin: 'auto',
  minHeight: '100vh',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.spacing(12, 0),
}));

// ----------------------------------------------------------------------

export default function LoginPage() {
  const mdUp = useResponsive('up', 'md');

  const imageLocation = '/assets/images/feaures/feature-image-login.png';

  return (
    <>
      <title> Login | HSTA Skillpassport Admin Console </title>

      {/* <StyledRoot> */}


      <Grid container sx={{}}>
        <Grid
          display={{ xs: 'none', sm: 'none', md: 'block' }}
          item
          xs={0}
          md={7}
          sx={{
            width: '100%',
            height: '100vh',
            backgroundColor: 'yellow',
            position: 'relative',
            p: 0,
          }}
        >
          <Box
            component="img"
            src={imageLocation}
            alt="cover"
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              display: 'block',
            }}
          />
        </Grid>
        <Grid item xs={12} md={5} sx={{ width: '100%', height: '100vh', backgroundColor: '#eee' }}>
          <Stack
            direction="column"
            alignItems={"center"}
            justifyContent="center"
            sx={{ minHeight: '100vh', py: 12 }}
          >
            <Logo />

            <Typography variant="h4" sx={{ mt: 2 }}>
              {/* SkillPassport AI運動平台 */}
              AI運動平台
            </Typography>

            <Typography variant="h5">
              登入
            </Typography>

            <Box sx={{ py: 2, px: 4, width: '100%' }}>
              <LoginForm />
            </Box>
          </Stack>
        </Grid>
      </Grid>

      {/* </StyledRoot> */}
    </>
  );
}
